import { GIG_URL_PARAMS, ContactTriggerValue } from '../../reducers/packages/utils/constants';
import { extractQueryParams } from '../queryParams/extract/extractQueryParams';

const consumed = new Map<ContactTriggerValue, boolean>();

const stripParamFromUrl = () => {
    if (typeof window === 'undefined' || !window.history?.replaceState) {
        return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete(GIG_URL_PARAMS.OPEN_CONTACT);
    window.history.replaceState({}, '', url.toString());
};

/**
 * Sets the openContact query param on the current URL and reloads the page so
 * the trigger survives the identification flow's redirect. Mirrors the
 * sessionStorage-based pattern used by the Payment Drawer, but URL-based.
 */
export const saveContactTriggerAndRefreshPage = (triggerValue: ContactTriggerValue): void => {
    if (typeof window === 'undefined') {
        return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(GIG_URL_PARAMS.OPEN_CONTACT, triggerValue);
    window.location.search = searchParams.toString();
};

export const peekContactTrigger = (): ContactTriggerValue | undefined => {
    const { openContact } = extractQueryParams() as { openContact?: ContactTriggerValue };
    return openContact;
};

/**
 * Returns true the first time the current page load's `openContact` query param
 * matches `expectedValue`. Subsequent calls (including from other mounted
 * components) return false. The param is removed from the URL on the first
 * match so a refresh doesn't re-trigger the action.
 */
export const consumeContactTrigger = (expectedValue: ContactTriggerValue): boolean => {
    if (consumed.get(expectedValue)) {
        return false;
    }

    const { openContact } = extractQueryParams() as { openContact?: string };
    if (openContact !== expectedValue) {
        return false;
    }

    consumed.set(expectedValue, true);
    stripParamFromUrl();
    return true;
};
